import React from 'react'

//@MUI
import Box from '@mui/material/Box'
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'

const CustomSelect = ({
  label,
  name,
  options,
  value,
  onChange,
  size,
  customLG,
}) => (
  <Grid item xs={12} lg={customLG ?? 4}>
    <FormControl fullWidth size={size}>
      <InputLabel>{label}</InputLabel>
      <Select value={value ?? ''} onChange={onChange} name={name} label={label}>
        {options.map((o) => (
          <MenuItem value={o} key={o}>
            {o}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default React.memo(CustomSelect)
